import React from 'react';
import { Content, Header, Layout, SectionTitle, SEO, Wrapper } from '../components';

import PageProps from '../models/PageProps';

export default class ContactPage extends React.Component<PageProps> {
  public render() {
    return (
      <Layout>
        <SEO titlePrefix={`Events | `} isPost={false}/>
        <Header banner={'https://www.teliacompany.com/globalassets/telia-company/images/decorative-images/hero-1680x333/hero_about2.jpg'}>
          <SectionTitle uppercase={true}>Events</SectionTitle>
        </Header>
        <Wrapper>
          <Content>
            <h1>Work In Progress!</h1>
          </Content>
        </Wrapper>
      </Layout>
    );
  }
}
